export const baseUrls = {
  facebook: 'https://www.facebook.com/',
  twitter: 'https://twitter.com/',
  instagram: 'https://www.instagram.com/',
  linkedin: 'https://www.linkedin.com/',
  pinterest: 'https://www.pinterest.com/',
};

export const followPaths = {
  facebook: 'LendingClubTeam',
  twitter: 'LendingClub',
  instagram: 'lendingclub',
  linkedin: 'company/lending-club',
  pinterest: 'lendingclub',
};

export const sharePaths = {
  facebook: 'sharer.php?u=',
  twitter: 'share?url=',
  linkedin: 'shareArticle?url=',
};
